const FAULT_CODE_I18N_KEYS = {
  1: 'bike.name420',
  2: 'bike.name421',
  3: 'bike.name422',
  4: 'bike.name423',
  5: 'bike.name424',
  6: 'bike.name425',
  7: 'bike.name426',
  8: 'bike.name427',
  9: 'bike.name428',
  10: 'bike.name429',
  11: 'bike.name430',
  12: 'bike.name431',
  13: 'bike.name432',
  14: 'bike.name433',
  15: 'bike.name434',
  16: 'bike.name435',
  17: 'bike.name436',
  18: 'bike.name437',
  19: 'bike.name583',
  30: 'bike.name438',
  48: 'bike.name582'
}

export function normalizeFaultCode (faultCode) {
  if (faultCode == null || faultCode === '') return ''
  const parsed = parseInt(String(faultCode), 10)
  if (Number.isNaN(parsed)) return String(faultCode)
  return String(parsed)
}

/**
 * @param {object} vm - Vue 实例（用于 $t）
 * @param {string|number} faultCode - IoT 故障码
 * @param {string} [faultMessage] - 后端原始故障描述；未知故障码时回退展示
 */
export function getFaultCodeLabel (vm, faultCode, faultMessage) {
  const normalized = normalizeFaultCode(faultCode)
  if (!normalized) return faultMessage || ''
  const key = FAULT_CODE_I18N_KEYS[normalized]
  if (key) return vm.$t(key)
  // 未映射的新故障码：保留后端文案，避免英文模式下单元格空白
  return faultMessage || normalized
}
